export const images = {
    DESKTOP_BG: "/images/mobileBlueBg.svg",
    MOBILE_BG: "/images/mobileBlueBg.svg"
}

export const icons = {
    GREEN_TICK: "/images/greenTick.svg",
    EMAIL_FAIL: "/images/emailFail.svg"
}